import enMessages from './en';
import esMessages from './es';
import deMessages from './de';
// todo if you want to add another lang add here the import, copy one of the files and edit it
export const messages = { 'en-US': enMessages, 'es-ES': esMessages, 'de-DE': deMessages };
